import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Grid, TextItem, DateItem, CountItem, AmountItem } from 'common/components/summary';
import getSettings from 'common/utils/settings';

const getProductName = ({ type }, settingsKey) => getSettings(['simulation', settingsKey, type, 'name']) || type;

const getProductInvestmentAmount = ({ type, parts }, settingsKey, duration) => {
    const productSettings = getSettings(['simulation', settingsKey, type]);
    const partValue = productSettings && productSettings.value;

    if (!partValue || !parts) {
        return null;
    }

    const investmentAmount = partValue * parts;

    return 'dismemberedScpi' === settingsKey
        ? investmentAmount * productSettings.share[duration].bareOwnership
        : investmentAmount;
};

const SCPI = ({
    type,
    recommendation: {
        subscriptionDate,
        duration,
        products,
    },
}) => {
    const isDismembered = 'SCPIDemembreeCIF' === type;
    const settingsKey = isDismembered ? 'dismemberedScpi' : 'scpi';

    return (
        <Fragment>
            <Grid size={3}>
                <DateItem title="Date de souscription" value={subscriptionDate} />
                <TextItem
                    title={isDismembered ? 'Durée du démembrement' : "Durée de l'investissement"}
                    value={duration ? `${duration} ans` : '-'}
                />
            </Grid>
            {products && products.map((product, index) => (
                <Grid size={3} key={product.id || index}>
                    <TextItem title="Produit" value={getProductName(product, settingsKey)} />
                    <CountItem title="Nombre de parts" value={product.parts} />
                    <AmountItem
                        title="Montant investissement"
                        value={getProductInvestmentAmount(product, settingsKey, duration)}
                    />
                </Grid>
            ))}
        </Fragment>
    );
};

SCPI.propTypes = {
    type: PropTypes.string.isRequired,
    recommendation: PropTypes.shape({
        subscriptionDate: PropTypes.string,
        duration: PropTypes.number,
        products: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            parts: PropTypes.number,
        })),
    }).isRequired,
};

export default SCPI;
